
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GmailProviderSetup from "./GmailProviderSetup";
import OutlookProviderSetup from "./OutlookProviderSetup";
import AIProvidersSetup from "./AIProvidersSetup";
import { EmailProvider } from "@/types/email";

interface ProviderTabsProps {
  providers: EmailProvider[];
  onProviderUpdated: () => void;
  defaultTab?: string;
}

const ProviderTabs = ({ providers, onProviderUpdated, defaultTab = "email" }: ProviderTabsProps) => {
  const gmailProvider = providers.find(p => p.name === "gmail");
  const outlookProvider = providers.find(p => p.name === "outlook");
  const openaiProvider = providers.find(p => p.name === "openai");
  const perplexityProvider = providers.find(p => p.name === "perplexity");
  
  return (
    <Tabs defaultValue={defaultTab}>
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="email">Email</TabsTrigger>
        <TabsTrigger value="ai">AI Services</TabsTrigger>
      </TabsList>
      
      <TabsContent value="email" className="space-y-4 mt-4">
        <Tabs defaultValue="gmail">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="gmail">Gmail</TabsTrigger>
            <TabsTrigger value="outlook">Outlook</TabsTrigger>
          </TabsList>
          
          <TabsContent value="gmail" className="space-y-4 mt-4">
            <GmailProviderSetup 
              provider={gmailProvider} 
              onUpdate={onProviderUpdated} 
            />
          </TabsContent>
          
          <TabsContent value="outlook" className="space-y-4 mt-4">
            <OutlookProviderSetup 
              provider={outlookProvider}
              onUpdate={onProviderUpdated} 
            />
          </TabsContent>
        </Tabs>
      </TabsContent>
      
      <TabsContent value="ai" className="space-y-4 mt-4">
        <AIProvidersSetup 
          openaiProvider={openaiProvider}
          perplexityProvider={perplexityProvider}
          onUpdate={onProviderUpdated}
        />
      </TabsContent>
    </Tabs>
  );
};

export default ProviderTabs;
